// extracted by mini-css-extract-plugin
export var content = "styles-module__content___QLupB";
export var heading = "styles-module__heading___UC9PI";
export var hero = "styles-module__hero___pvONC";
export var img = "styles-module__img___I9hM7";
export var introduction = "styles-module__introduction___lPE8o";
export var picture = "styles-module__picture___EieCk";
export var secondary = "styles-module__secondary___Verqa";
export var stepper = "styles-module__stepper___ufpgL";